export const createHighlighterBadge = (tabType, badge, percentageValue, trendType) => {
  if (!badge?.length) {
    const badgeList = [];
    if (percentageValue && trendType !== "up") badgeList.push(`% ${percentageValue}`);
    return badgeList;
  } else {
    const sortingList = [
      "promotion",
      "opportunity",
      `${percentageValue && trendType !== "up" ? `% ${percentageValue}` : ""}`,
      "new",
    ];

    if (tabType === "price-down") [[sortingList[1]], [sortingList[2]]] = [[sortingList[2]], [sortingList[1]]];
    else if (tabType === "platinum") sortingList.unshift("platinum");

    const list = arraySort(sortingList, badge);
    return [list[0], list[1]];
  }
};

const arraySort = (sortList, badge) => {
  return sortList.reduce((list, item) => {
    if (item.includes("%") || badge.includes(item)) list.push(item);
    return list;
  }, []);
};
